import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a89cf90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-select-wrapper__label"
}
const _hoisted_2 = { class: "input-error" }

import AppSelect from '@C/ui/form/AppSelect/AppSelect.vue'

interface Props {
  options: unknown[]
  label?: string
  placeholder?: string
  isError?: boolean
  errorText?: string
  wrapperClass?: string | string[]
}


const __default__ = { inheritAttrs: false }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AppSelectWrapper',
  props: {
    options: {},
    label: {},
    placeholder: {},
    isError: { type: Boolean },
    errorText: {},
    wrapperClass: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-select-wrapper", _ctx.wrapperClass])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode(AppSelect, _mergeProps({
      options: _ctx.options,
      placeholder: _ctx.placeholder,
      class: { 'v-select_invalid': _ctx.isError }
    }, _ctx.$attrs), _createSlots({ _: 2 }, [
      _renderList(_ctx.$slots, (_, slot) => {
        return {
          name: slot,
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
          ])
        }
      }),
      (_ctx.isError)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.errorText), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1040, ["options", "placeholder", "class"])
  ], 2))
}
}

})